import { __rest } from "tslib";
import React from 'react';
import NextLink from './components/NextLink';
import ReactLink from './components/ReactLink';
export const DefaultLink = (_a) => {
    var { href = '', children } = _a, rest = __rest(_a, ["href", "children"]);
    return (React.createElement("a", Object.assign({ href: href }, rest), children));
};
const Link = (_a) => {
    var { href = '', locale, children } = _a, rest = __rest(_a, ["href", "locale", "children"]);
    if (process.env.TYPE_OF_LINK === 'browser') {
        const reactProps = Object.assign({ to: href }, rest);
        return React.createElement(ReactLink, Object.assign({}, reactProps), children);
    }
    if (process.env.TYPE_OF_LINK === 'server') {
        const nextProps = Object.assign({ href,
            locale }, rest);
        return React.createElement(NextLink, Object.assign({}, nextProps), children);
    }
    return (React.createElement(DefaultLink, Object.assign({ href: href }, rest), children));
};
export default Link;
//# sourceMappingURL=Link.js.map